import { render, staticRenderFns } from "./ContactSent.vue?vue&type=template&id=6f1edcc2&scoped=true&"
import script from "./ContactSent.vue?vue&type=script&lang=ts&"
export * from "./ContactSent.vue?vue&type=script&lang=ts&"
import style0 from "./ContactSent.vue?vue&type=style&index=0&id=6f1edcc2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1edcc2",
  null
  
)

export default component.exports